import type { WidgetConfig } from '@examdojo/core/widget';
import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, WidgetBlock } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertWidgetBlockToTiptap = ((block) => {
  return {
    type: 'widget',
    attrs: {
      widget_type: block.widget_type,
      config: block.config,
      ...(block.title && { title: block.title }),
    },
  };
}) satisfies BlockToTiptapConverter<WidgetBlock>;

export function convertTiptapToWidgetBlock(json: JSONContent): WidgetBlock {
  const attrs = json.attrs ?? {};

  return {
    id: uuid(),
    type: ContentBlockType.Widget,
    widget_type: attrs['widget_type'] as string,
    config: attrs['config'] as WidgetConfig,
    ...(attrs['title'] && { title: attrs['title'] as string }),
  };
}
